import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {FPNetDate, ObjectFactory} from "@commons/types";

export interface SettoreContrattiRecord {
    settore: string | null,
    contratti: CCNLRecord[],
}

export interface CCNLRecord extends URIAndTrace {
    settore: string | null,
    codContratto: string | null,
    codContrattoUNILAV: string | null,
    descrizione: string,
    fineValidita: FPNetDate,
    inizioValidita: FPNetDate,
    tipologiaCCNL: 'NUOVO' | 'VECCHIO' | undefined, // SOLO per FrontEnd
    numMensilita: number
}

export interface CCNLLivelloRecord extends URIAndTrace {
    codLivello: string | null,
    descrizione: string | null,
    codLivelloUNILAV: string | null,
    descrizioneUNILAV: string | null,
    rml: number | null,
    codContratto: string | null,
    codContrattoUNILAV: string | null,
    ordinamento: number,
    tipologia: 'NON_DEFINITO' | 'QUALIFICATO' | 'APPRENDISTA' | null,
    numMensilita: number,
    divisoreOrario: number | null,
    inizioValidita: FPNetDate,
    fineValidita: FPNetDate,

}

export class CCNLLivelloRecord {
    static factory: ObjectFactory<CCNLLivelloRecord> = (json?) => {
        return {
            codContratto: (json && json.codContratto) ? json.codContratto : null,
            codContrattoUNILAV: (json && json.codContrattoUNILAV) ? json.codContrattoUNILAV : null,
            ordinamento: (json && json.ordinamento) ? json.ordinamento : 0,
            tipologia: (json && json.tipologia) ? json.tipologia : null,
            numMensilita: (json && json.numMensilita) ? json.numMensilita : 13,
            divisoreOrario: (json && json.divisoreOrario) ? json.divisoreOrario : null,
            codLivello: (json && json.codLivello) ? json.codLivello : null,
            codLivelloUNILAV: (json && json.codLivelloUNILAV) ? json.codLivelloUNILAV : null,
            descrizione: (json && json.descrizione) ? json.descrizione : null,
            descrizioneUNILAV: (json && json.descrizioneUNILAV) ? json.descrizioneUNILAV : null,
            rml: (json && json.rml) ? json.rml : null,
            inizioValidita: (json && json.inizioValidita) ? json.inizioValidita : null,
            fineValidita: (json && json.fineValidita) ? json.fineValidita : null,

            URI: null,
        };
    }
}

export class CCNLRecord {
    static factory: ObjectFactory<CCNLRecord> = (json?) => {
        return {
            settore: (json && json.settore) ? json.settore : null,
            codContratto: (json && json.codContratto) ? json.codContratto : null,
            codContrattoUNILAV: (json && json.codContrattoUNILAV) ? json.codContrattoUNILAV : null,
            descrizione: (json && json.descrizione) ? json.descrizione : '',
            fineValidita: (json && json.fineValidita) ? json.fineValidita : null,
            inizioValidita: (json && json.inizioValidita) ? json.inizioValidita : null,
            tipologiaCCNL: (json && json.tipologiaCCNL) ? json.tipologiaCCNL : 'NUOVO', // SOLO per FrontEnd
            numMensilita: (json && json.numMensilita) ? json.numMensilita : 13,

            URI: null,
        }
    }
}